import { render, staticRenderFns } from "./SkillSimClassPicker.vue?vue&type=template&id=e604ed08&scoped=true&"
import script from "./SkillSimClassPicker.vue?vue&type=script&lang=ts&"
export * from "./SkillSimClassPicker.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSimClassPicker.vue?vue&type=style&index=0&id=e604ed08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e604ed08",
  null
  
)

export default component.exports